import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ATTRIBUTES, SELECTORS } from '@/entry/_critical'

export class CardColorSwatches extends UcoastEl {
    static htmlSelector = 'card-color-swatches'
    constructor() {
        super()

        q.ol('.card-color-swatch__link', this)?.forEach(swatch => {
            swatch.addEventListener('click', this.onClickSwatch.bind(this))
        })
    }

    async onClickSwatch(event: Event) {
        event.preventDefault()
        const target = q.rClosestTarget(event, '.card-color-swatch__link') as HTMLLinkElement
        if (!target) return
        const id = target.dataset.id
        const handle = target.dataset.handle
        const container = target.closest('.card-wrapper--content') || target.closest('.product-upsell-card') as HTMLElement
        if (!container) return
        target.setAttribute(ATTRIBUTES.loading, '')
        q.rs(SELECTORS.loadingOverlaySpinner, target).classList.remove('hidden')
        q.ol('.card-color-swatch__link', this)?.forEach(swatch => {
            if (swatch.dataset.id == id) swatch.classList.add('active')
            else swatch.classList.remove('active')
        })
        const sectionId = container.classList.contains('card-wrapper--content')
            ? 'card-product-content'
            : 'product-upsell-card';

        const response = await fetch(`/products/${handle}?section_id=${sectionId}`, {
            credentials: 'same-origin',
            method: 'GET',
        })
        const responseText = await response.text()
        const card = q.rs('.card-wrapper', new DOMParser().parseFromString(responseText, 'text/html'))
        if(!card) return
        container.innerHTML = card.outerHTML
    }
}
